import { AxiosError } from "axios";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";

export const postMemberIdentificationSend = async (
  email: string
): Promise<TApiResult> => {
  return client()
    .member.identification_send.post({ body: { email: email } })
    .then(() => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
      };
    })
    .catch((e: AxiosError) => {
      const { status, message, errorMessages } = getErrorProperty(
        e,
        "postMemberIdentificationSend"
      );

      const invalidMessage =
        status === 409
          ? message
          : errorMessages && errorMessages.details.length > 0
          ? errorMessages.details[0].values.join(" ")
          : "正しいメールアドレスを入力してください。";

      return {
        isSuccess: false,
        status: status,
        message: invalidMessage,
      };
    });
};
